<template>
  <div class="asd20-teams-filters">
    <asd20-viewport id="Type" scrollable>
      <asd20-list>
        <asd20-list-item
          v-for="(item, index) in filteredGroupsListItems"
          :key="index"
          v-bind="item"
          @click.native="openGroup(item.group)"
          :checked="
            $route.params.slug && $route.params.slug === item.group.slug
          "
        />
      </asd20-list>
    </asd20-viewport>
    <asd20-modal
      :open="!!selectedGroup"
      title="Team Details"
      icon="list"
      dismissable
      @dismiss="selectedGroup = null"
      windowed
    >
      <asd20-viewport scrollable>
        <asd20-department-contact-card :group="selectedGroup" expanded />
      </asd20-viewport>
    </asd20-modal>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'
import Asd20List from '@asd20/ui/src/components/organisms/Asd20List'
import Asd20ListItem from '@asd20/ui/src/components/molecules/Asd20ListItem'
import Asd20Modal from '@asd20/ui/src/components/molecules/Asd20Modal'
import Asd20Viewport from '@asd20/ui/src/components/atoms/Asd20Viewport'
import Asd20DepartmentContactCard from '@asd20/ui/src/components/molecules/Asd20DepartmentContactCard'

export default {
  name: 'Asd20PeopleFilters',
  components: {
    Asd20List,
    Asd20ListItem,
    Asd20Modal,
    Asd20Viewport,
    Asd20DepartmentContactCard,
  },
  props: {
    slug: { type: String },
  },

  data: () => ({
    selectedGroup: null,
  }),

  computed: {
    filteredGroupsListItems: get('groups/filteredGroupsListItems'),
  },

  methods: {
    openGroup(group) {
      this.$router.push({ name: 'team', params: { slug: group.slug } })
    },
  },
}
</script>

<style lang="scss">
@import '@asd20/ui/src/design/_variables.scss';

.asd20-teams-filters {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-grow: 1;

  .asd20-viewport {
    // padding-top: space(1);
    margin-bottom: auto;
    flex-grow: 0;
  }
}

@media (min-width: 1024px) {
  .asd20-teams-filters {
  }
}
</style>
